/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadUmamiScript } from "./analytics";

const UMAMI_SRC = process.env.BUN_PUBLIC_UMAMI_SCRIPT_URL ?? "";
const UMAMI_ID = process.env.BUN_PUBLIC_UMAMI_WEBSITE_ID ?? "";
if (UMAMI_SRC && UMAMI_ID) {
  loadUmamiScript({ src: UMAMI_SRC, websiteId: UMAMI_ID });
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
